import DataFooterButtons from '@/features/DataHub/components/ExportDrawer/DataFooterButtons';
import ImageFooterButtons from '@/features/DataHub/components/ExportDrawer/ImageFooterButtons';
import { useExport } from '@/features/DataHub/modules/Export/context/ExportContext';
import { ExportTypes } from '@/features/DataHub/modules/Export/types';

const FooterButtons = () => {
  const { exportSettings } = useExport();
  if (exportSettings.exportType === ExportTypes.DATA) return <DataFooterButtons />;
  if (exportSettings.exportType === ExportTypes.IMAGE && exportSettings.exportSubType)
    return <ImageFooterButtons />;
};
export default FooterButtons;
